import React, { memo } from 'react';
import classnames from 'classnames';
import { PREFIX } from '@zmedia/bm-soccer-ui/constants';
import Element from '../../element';
interface IProps {
    className?: string;
    children: React.ReactNode;
}

function NavbarBrand(props: IProps) {
    const { children, className, ...rest } = props;

    return (
        <Element
            {...rest}
            className={classnames(`${PREFIX}-navbar-brand`, className)}
        >
            {children}
        </Element>
    );
}

export default memo(NavbarBrand);
